import { ApprovalParamSelection } from 'ng2-app/store/offers/approvals.state';
import { Approval } from '../../models/dto/approval/approval.model';

export class SubscribeToApprovals {
	static readonly type = '[Approval] SubscribeToApprovals';
	constructor(public dealId: number) {}
}

export class GetApprovals {
	static readonly type = '[Approval] GetApprovals';
	constructor(public borrowerId: number) {}
}

export class GetApprovalsCount {
	static readonly type = '[Approval] GetApprovalsCount';
	constructor(public borrowerId: number) {}
}

export class UpdateApproval {
	static readonly type = '[Approval] Update';
	constructor(public offer: Approval) {}
}

export class SetApprovalCalculator {
  static readonly type = '[Approval Calculator] SetApprovalCalculator';
  constructor(public params: ApprovalParamSelection) {}
}

export class GetApprovalCalculatorStorage {
  static readonly type = '[Approval Calculator] GetApprovalCalculatorStorage';
  constructor() {}
}

export class GetAdjustedApproval {
	static readonly type = '[Approval] GetAdjustedApproval';
	constructor(
		public approvalId: number,
		public amount: number,
		public term: number,
		public points: number,
		public frequency: string,
		public origination: number) {}
}

export class UpdatePublishApproval {
	static readonly type = '[Approval] UpdatePublishApproval';
	constructor(
		public approvalId: number,
	) {}
}
	export class UpdateUnpublishApproval {
		static readonly type = '[Approval] UpdateUnpublishApproval';
		constructor(
			public approvalId: number,
		) {}
	}

